// Professional skill groups — used by the capability marquee and the
// capability filters on the All Work timeline.
export const SKILL_GROUPS = [
  {
    id: 'creative',
    label: 'Creative and Brand Strategy',
    skills: ['Creative Direction', 'Brand Strategy', 'Brand Positioning', 'Brand Storytelling', 'Creative Concept Development', 'Art Direction', 'Visual Identity', 'Campaign Strategy'],
  },
  {
    id: 'content',
    label: 'Content and Communication',
    skills: ['Content Strategy', 'Content Ecosystem Architecture', 'Social Media Strategy', 'Video-First Content Strategy', 'Copywriting', 'Scriptwriting', 'Storyboarding', 'Editorial Strategy', 'Platform-Native Storytelling'],
  },
  {
    id: 'production',
    label: 'Production and Campaigns',
    skills: ['Video Production', 'Creative Production', 'Production Management', 'Film Direction', 'Post-Production', 'Integrated Campaigns', '360-Degree Campaign Strategy', 'Influencer Marketing', 'Branded Entertainment', 'Multi-Market Adaptation'],
  },
  {
    id: 'digital',
    label: 'Digital and Performance',
    skills: ['Instagram Reels Strategy', 'YouTube Strategy', 'Community-Led Content', 'UGC Strategy', 'Creator Partnerships', 'Performance Marketing', 'Engagement Optimisation', 'Content Analytics', 'Campaign Measurement'],
  },
  {
    id: 'ai',
    label: 'AI, Design and Automation',
    skills: ['AI-Assisted Art Direction', 'Generative AI Workflows', 'AI-Assisted Visual Development', 'Prompt Engineering', 'AI-Assisted Content Production', 'Creative Workflow Automation', 'AI-Assisted Prototyping', 'Vibe Coding', 'No-Code and Low-Code Development', 'Creative Technology Exploration'],
  },
];

export const CAPABILITY_FILTERS = [
  { id: 'cd', label: 'Creative Direction', match: /creative direction|art direction|film direction/i },
  { id: 'bs', label: 'Brand Strategy', match: /brand strategy|brand positioning|brand communication|visual identity/i },
  { id: 'cs', label: 'Content Strategy', match: /content strategy|content leadership|editorial|storytelling/i },
  { id: 'vp', label: 'Video Production', match: /video production|production|post-production|film direction/i },
  { id: 'sm', label: 'Social Media', match: /social media|community|ugc|instagram|creator|reels/i },
  { id: 'ai', label: 'AI and Automation', match: /generative ai|ai-assisted|automation|prompt engineering/i },
];
